import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Label2, Label3 } from '../../../../components/Typography/next';
import { useUserDataContext } from '../../../../contexts/UserData';
import {Info} from '@styled-icons/fluentui-system-filled/Info';

// Main Toggle Container
const ToggleContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${({lightMode, theme}) => lightMode ? 'rgba(255, 255, 255, 0.10)' : theme.colors.neutralsPalette.light};
  border-radius: 256px;
  padding: 4px;
`;

// Individual Toggle Option
const ToggleOption = styled(Label2)`
  display: flex;
  text-align: center;
  padding: 9px 12px;
  border-radius: 18px;
  cursor: pointer;
  user-select: none;
  font-weight: 400;
  transition: background 0.3s ease, color 0.3s ease;
  color: ${({theme, lightMode, isActive}) => !isActive && lightMode ? 'white' : theme.colors.typographyPalette.primary};


  ${({ isActive }) =>
    isActive
      ? `
      background: white;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.10);
    `
      : `

    `}
`;
const LinkWrapper = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ne-resize;
`;

const InfoIcon = styled(Info)`
  width: 14px;
  height: 14px;
  color: ${({theme, lightMode, isActive}) => (lightMode && !isActive) ? theme.colors.iconPalette.transparent  : theme.colors.typographyPalette.tertiary};
  margin-left: 4px;

  &:hover {
    color: ${({theme, lightMode, isActive}) => !isActive ? theme.colors.neutralsPalette.extraLight : theme.colors.typographyPalette.secondary};
  }
`;

const TextToggle = ({
  className,
  onChange,
  options=[],
  defaultOptionValue,
  lightMode
}) => {
  const defaultState = options?.find(option => option.value === defaultOptionValue) || options[0];
  const [selectedOption, setSelectedOption] = useState(defaultState);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    onChange(option.value);
  };

  const renderIcon = (icon, isActive) => {
    const IconComponent = icon;

    return <IconComponent lightMode={lightMode} isActive={isActive}/>;
  };

  useEffect(() => {
    if (selectedOption.value !== defaultOptionValue) {
      const defaultOption = options?.find(option => option?.value === defaultOptionValue);

      if (defaultOption) setSelectedOption(defaultOption);
    }
  }, [defaultOptionValue]);

  return (
    <ToggleContainer className={className} lightMode={lightMode}>
      {options.map((option, index) => (
        <ToggleOption
          key={`toggle-option-${option.value}`}
          isActive={selectedOption.value === option.value}
          onClick={() => handleOptionChange(option)}
          lightMode={lightMode}
        >
          {option.text}
          {option.icon && renderIcon(option.icon, selectedOption.value === option.value)}
        </ToggleOption>

      ))}
    </ToggleContainer>
  );
};

const InfoIconLink = ({lightMode, isActive}) => {
  const handleClick = e => {
    e.stopPropagation();
  };

  return (
    <LinkWrapper target={'_blank'} href={'https://bootcamp.com/blog/upcoming-changes-to-dat-scoring-and-reporting-march-1-2025'} onClick={handleClick}>
      <InfoIcon lightMode={lightMode} isActive={isActive}/>
    </LinkWrapper>
  );
}

export default TextToggle;
